module.exports = __webpack_public_path__ + "img/pie_s_chart.69ee4cda.svg";